import React, { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import emp1 from "../../../assets/overview_img/Platformimg/emp1.webp";
import emp2 from "../../../assets/overview_img/Platformimg/emp2.webp";
import emp3 from "../../../assets/overview_img/Platformimg/emp3.webp";
import emp4 from "../../../assets/overview_img/Platformimg/emp4.webp";

import user1 from "../../../assets/overview_img/Platformimg/employer1.webp";
import user2 from "../../../assets/overview_img/Platformimg/empoloyer2.webp";
import user3 from "../../../assets/overview_img/Platformimg/employer3.webp";
import user4 from "../../../assets/overview_img/Platformimg/employer4.webp";

function PlatformTabs() {
  const sliderRef = useRef(null);
  const [activeTab, setActiveTab] = useState("employers");
  const [isSticky, setIsSticky] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(true);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const updateScrollButtons = () => {
    const slider = sliderRef.current;
    if (!slider) return;

    const { scrollLeft, scrollWidth, clientWidth } = slider;
    const maxScrollLeft = scrollWidth - clientWidth;

    setCanScrollLeft(scrollLeft > 10);
    setCanScrollRight(scrollLeft < maxScrollLeft - 10);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 250) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: true,
    });

    return () =>
      window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    updateScrollButtons();

    const handleSliderScroll = () => {
      updateScrollButtons();
    };

    slider.addEventListener("scroll", handleSliderScroll);
    window.addEventListener("resize", updateScrollButtons);

    return () => {
      slider.removeEventListener("scroll", handleSliderScroll);
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, [activeTab]);

  const tabData = {
    employers: {
   title: (
  <>
    {/* Mobile */}
    <span className="block sm:hidden">
      Empower your
      <br />
      workforce with flexible
      <br />
      pay
    </span>

    {/* Tablet */}
    <span className="hidden sm:block  lg:hidden whitespace-nowrap">
      Empower your workforce with flexible pay
    </span>

    {/* Laptop/Desktop */}
    <span className="hidden lg:block">
      Empower your workforce with
      <br />
      flexible pay
    </span>
  </>
),
      description:
        "PayMeDaily your employees get control over their pay without adding extra work for your payroll  team.  ",
      cards: [
        {
          title: "Client Portal",
          desc:
            "PaymeDaily Tips provides your employees with real-time digital tip access, helping you simplify operations, reduce risk, and empower your employees. It integrates seamlessly with PayMeDaily's On-Demand Pay platform, making digital tip access scalable and manageable.",

          image: emp1,
          imageClass: `
           w-[220px] h-[220px]
           sm:w-[260px] sm:h-[260px]
           md:w-[210px] md:h-[71px] md:overflow-visible
           lg:w-[300px] lg:h-[340px]
     `,
        },

        {
          title: "Tips",
          desc:
            "PaymeDaily Tips provides your employees with real-time digital tip access, helping you simplify operations, reduce risk, and empower your employees. It integrates seamlessly with PayMeDaily's On-Demand Pay platform, making digital tip access scalable and manageable.",

          image: emp2,
        },

        {
          title: "Cycle",
          desc:
            "PaymeDaily Tips provides your employees with real-time digital tip access, helping you simplify operations, reduce risk, and empower your employees. It integrates seamlessly with PayMeDaily's On-Demand Pay platform, making digital tip access scalable and manageable.",

          image: emp3,
        },

        {
          title: "Reward",
          desc:
            "PaymeDaily Tips provides your employees with real-time digital tip access, helping you simplify operations, reduce risk, and empower your employees. It integrates seamlessly with PayMeDaily's On-Demand Pay platform, making digital tip access scalable and manageable.",

          image: emp4,
        },
        {
          title: "Reward",
          desc:
            "PaymeDaily Tips provides your employees with real-time digital tip access, helping you simplify operations, reduce risk, and empower your employees. It integrates seamlessly with PayMeDaily's On-Demand Pay platform, making digital tip access scalable and manageable.",

          image: emp4,
        },
      ],
    },

    employees: {
      title:
        "The Financial Wellness Platform for Your Entire Workforce",

      description:
        "Financial wellness isn’t one-size-fits-all. The PaymeDaily employee app meets each employee where they are, whether their goal is paying a bill today, monitoring credit for tomorrow, or saving for the future.",

      cards: [
        {
          title: "On-Demand Pay",
          desc:
            "Your team can get paid whenever they need it, not just on payday. With instant access to their earned wages, they’ll enjoy more financial flexibility.",

          image: user1,
        },

        {
          title: "PayMeDaily Visa® Prepaid Card",
          desc:
            "Employees can instantly access their earnings with no fee,* earn up to 9% cash back  on everyday purchases, create goal-based savings jars, and spend anywhere Visa debit cards are accepted. ",

          image: user2,
        },

        {
          title: "Financial Wellness Tools",
          desc:
            "Free credit monitoring, goal-based savings, financial counseling, and paycheck tracking tools can help them address immediate financial needs while also preparing for the future.",

          image: user3,
        },

        {
          title: "Exclusive Perks",
          desc:
            "Help your workforce save thousands of dollars on their largest recurring expenses. Perks offers trusted, curated offers on essentials like car and home insurance, tax services, cell phone plans, and more.",

          image: user4,
        },
         {
          title: "Financial Wellness Tools",
          desc:
            "Free credit monitoring, goal-based savings, financial counseling, and paycheck tracking tools can help them address immediate financial needs while also preparing for the future.",

          image: user3,
        },
      ],
    },
  };

  return (
    <section className="relative bg-white overflow-visible -transform translate-y-[-80px]  ">

      {/* STICKY BUTTONS */}
      <div
        className={`
          sticky
          top-[200px]
          
          z-50
          flex
          justify-center
          transition-all
          duration-300
          ${
            isSticky
              ? "scale-[0.88]"
              : "scale-100"
          }
        `}
      >
        <div
          className="
            bg-white
            border
            border-gray-300
            rounded-full
            p-2
            flex
            items-center
            shadow-md

            w-[420px]
            sm:w-[520px]
            md:w-[650px]

            h-[58px]
            sm:h-[64px]

            -mt-6
          "
        >
          <button
            onClick={() => setActiveTab("employers")}
            className={`
              flex-1
              h-full
              rounded-full
              font-semibold
              transition-all
              duration-300

              text-[14px]
              sm:text-[16px]
              md:text-[18px]

              ${
                activeTab === "employers"
                  ? "bg-[#290001] text-[white]"
                  : "text-gray-500"
              }
            `}
          >
            For Employers
          </button>

          <button
            onClick={() => setActiveTab("employees")}
            className={`
              flex-1
              h-full
              rounded-full
              font-semibold
              transition-all
              duration-300

              text-[14px]
              sm:text-[16px]
              md:text-[18px]

              ${
                activeTab === "employees"
                  ? "bg-[#290001] text-[white]"
                  : "text-gray-500"
              }
            `}
          >
            For Employees
          </button>
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-[1500px] mx-auto px-4 sm:px-6">

        {/* HEADING */}
        <h2
          className="
            text-center
            text-[#290001]
            font-serif
            leading-[1.05]
            

            text-[32px]
            sm:text-[42px]
            md:text-[32px]
            md:font-light
            lg:text-[42px]
            lg:mt-20
            lg: font-light 

            max-w-[600px]
            mx-auto
            mt-16
          "
          data-aos="fade-up"
          data-aos-delay="100"
        >
          {tabData[activeTab].title}
        </h2>

        {/* DESCRIPTION */}
        <p
          className="
            text-center
            text-[#290001]
            leading-[1.6]
            lg:leading-[1.5]
            md:leading-[1.5]


            text-[16px]
            md:text-[16px]
            md:font-sans

            max-w-[600px]
            mx-auto
            mt-6
          "
          data-aos="fade-up"
          data-aos-delay="150"
        >
          {tabData[activeTab].description}
        </p>

        {/* CARDS */}
<div className="relative mt-20">

  {/* LEFT ARROW */}
  <button
    onClick={() => {
      sliderRef.current?.scrollBy({
        left: -420,
        behavior: "smooth",
      });
    }}
    className={`
      absolute
      left-[-18px]
      top-1/2
      -translate-y-1/2
      z-20

      w-[54px]
      h-[54px]

      rounded-full
      bg-[#290001]
      lg:bg-[#290001]
      md:bg-[#290001]
      shadow-lg
      border
      border-gray-200

      flex
      items-center
      justify-center

      hover:scale-105
      transition
      ${canScrollLeft ? "block" : "hidden"}
    `}
  >
    <span className="text-[32px] text-[white] leading-none">
      ‹
    </span>
  </button>

  {/* RIGHT ARROW */}
  <button
    onClick={() => {
      sliderRef.current?.scrollBy({
        left: 420,
        behavior: "smooth",
      });
    }}
    className={`
      absolute
      right-[-18px]
      top-1/2
      -translate-y-1/2
      z-20

      w-[54px]
      h-[54px]

      rounded-full
      bg-[#290001]
      lg:bg-[#290001]
      md:bg-[#290001]
      shadow-lg
      border
      border-gray-200

      flex
      items-center
      justify-center

      hover:scale-105
      transition
      ${canScrollRight ? "block" : "hidden"}
    `}
  >
    <span className="text-[32px] text-[white] leading-none">
      ›
    </span>
  </button>

  {/* SLIDER */}
  <div
    id="platformSlider"
    ref={sliderRef}
    className="
      flex
      gap-6
      overflow-x-auto
      scroll-smooth
      pb-4

      [scrollbar-width:none]
      [-ms-overflow-style:none]
    "
  >
    {tabData[activeTab].cards.map((card, index) => (
      <div
        key={index}
        className="
          min-w-[300px]
          sm:min-w-[330px]
          md:min-w-[160px]
          lg:min-w-[330px]
          xl:min-w-[360px]

          bg-[#ecc2a1]
          md:bg-[#ecc2a1]
          lg:bg-[#ecdbce]
          rounded-[5px]
          md:rounded-[16px]
          lg:rounded-[5px]
          overflow-hidden

          flex
          flex-col
          justify-between

          h-[620px]
          md:h-[900px]
         lg:h-[520px]

          hover:-translate-y-1
          transition-all
          duration-300
        "
        data-aos="fade-up"
        data-aos-delay={`${100 + index * 100}`}
      >
        {/* TOP CONTENT */}
        <div
          className="p-8"
          data-aos="fade-left"
          data-aos-delay={`${100 + index * 100}`}
        >

          <h3
            className="
              text-[22px]
              lg:text-[24px]
              lg:leading-
              font-sans
              text-[#141414]
              leading-tight
            "
          >
            {card.title}
          </h3>

          <p
            className="
              mt-6
              text-[15px]
              leading-[1.7]
              text-[#290001]
            "
          >
            {card.desc}
          </p>

          <button
            className="
              mt-7
              text-[15px]
              font-bold
              text-black-500
              hover:underline 
              hover:text-[#290001]
            "
          >
            Learn more →
          </button>
        </div>

        {/* IMAGE */}
        <div
          className="
            w-full
            h-[290px]

            flex
            justify-center
            items-end
            overflow-hidden
          "
          data-aos="fade-right"
          data-aos-delay={`${150 + index * 100}`}
        >
         <img
  src={card.image}
  alt={card.title}
  className={`
    object-contain

    ${card.imageClass}
  `}
/>
        </div>
      </div>
    ))}
  </div>
</div>
</div>
    </section>
  );
}

export default PlatformTabs;